import HomeTopProfiles from "../features/home/HomeTopProfiles";
import Feed from "../features/home/Feed";

const Home = () => {
  return (
    <>
      <HomeTopProfiles />
      <Feed />
    </>
  );
};

export default Home;
